module.exports = __webpack_public_path__ + "static/media/success-icon.ee910beb.svg";